var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'app--' + _vm.$store.state.device,attrs:{"id":"app"}},[_c('header-' + _vm.$store.state.device,{tag:"component"}),_c('router-view'),_c('footer-' + _vm.$store.state.device,{tag:"component"}),_c('a-back-top')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }